/**
 * Establece la contraseña del usuario que acaba de entrar por un enlace de recuperación.
 *
 * 🔴 Lanza si el backend no confirma. No puede fallar en silencio: si se tragase el
 * error, el modal cantaría "contraseña creada", metería al usuario en el dashboard, y
 * esa persona se quedaría con la contraseña vieja que precisamente no recordaba — sin
 * ninguna vía de vuelta.
 *
 * No basta con mirar `response.ok`: comparsa responde HTTP 200 para TODO salvo los 500
 * (`AllExceptionFilter`), así que el resultado real vive en el `success` del cuerpo. El
 * caso que va a ocurrir es un 403 envuelto en un 200: el endpoint lleva `@Roles('user')`
 * y un admin o un gestor no lo tienen.
 *
 * ⚠️ El error NO arrastra el cuerpo de la respuesta. `set-password` devuelve la
 * contraseña EN CLARO y los dos hashes bcrypt; meterlos en el mensaje los dejaría en la
 * consola del navegador y en las grabaciones de Clarity.
 */
const setUserPassword = async (token: string, userId: string, newPassword: string) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/set-password/${userId}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify({ newPassword })
	});

	const parsed = await response.json().catch(() => null);

	if (!response.ok || parsed?.success !== true) {
		throw new Error(`No se pudo establecer la contraseña (HTTP ${response.status})`);
	}

	return parsed;
};

export default setUserPassword;
